import { ServiceOrderVehicleModel } from '../../../serviceOrders/shared/commonServiceOrder.types';
import { ApiServiceVehicleModel } from '../../types/serviceOrder/serviceVehicleApi.types';

export const mapToServiceVehicleModel = (apiServiceVehicleModel: ApiServiceVehicleModel): ServiceOrderVehicleModel => ({
    name: apiServiceVehicleModel.name,
    group: apiServiceVehicleModel.group,
    version: apiServiceVehicleModel.version,
    manufacturer: apiServiceVehicleModel.manufacturer,
});
